'use client';

import useAppErrorStore from '@/hooks/useAppErrorStore';
import Alert from '@/ui/alert';
import { type ReactNode, useEffect, useRef } from 'react';
export default function AppWarning({
  extra
}: {
  extra?: ReactNode;
}) {
  const {
    warning,
    resetWarning
  } = useAppErrorStore();
  const alertRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (alertRef.current) {
      alertRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [alertRef.current]);
  if (!warning) {
    return;
  }
  return <Alert title="Warning" onDismiss={resetWarning} variant="warning" ref={alertRef} description={<>
          <p>{warning.friendlyWarning}</p>

          {extra}
        </>} data-sentry-element="Alert" data-sentry-component="AppWarning" data-sentry-source-file="app-warning.tsx" />;
}